import React from 'react'

function AI_Review_Program_Page() {
  return (
    <div>
    <div>
      <div className='container'>
      <div className='row d-sm-block d-md-none'>
            <div className='col-md-1'></div>
            <div className='col-md-10'>
            <div className='text-center About_Discraption_text'>
                <h1 className='display-5 pb-2'>Testmonial</h1>
                <p className='fs-6'>Listen to the people who have made it! Explore the testimonies of former students who attested to the life-altering effects of their educational experiences.</p>
            </div>
            </div>
            <div className='col-md-1'></div>
        </div>
        <div className='row'>
            <div className='col-md-4 pt-5'>
                <div className='Program_review_comp p-5'>
                    <div className='mt-5'>
                        <h1 className='pt-5 display-6 review_component_text'>Hear What Our Students Says</h1>
                        <p className='pt-4 fs-5'>10,000+ Students have already learned with InternsElite</p>
                    </div>
                </div>
            </div>
            <div className='col-md-8'>
                <div className='row'>
                <div class="col-md-5 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Srijani Debnath</h5>
                    <h6 class="font-weight-bold my-2">Government College of Engineering & Leather Technology, Kolkata</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_white_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>The Training and Mentorship Part of This Program Was Quite Good.
                    </p>
                </div>
                </div>
                <div class="col-md-7 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Smit Kagathara</h5>
                    <h6 class="font-weight-bold my-2">LDRP-ITR (Gandhinagar, Gujarat), Computer Engineering</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_white_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>I Think That InternsElite has a Wonderful Agenda by Training People with a Variety of Courses and The Sessions Were Extraordinary and Very Helpful.
                    </p>
                </div>
                </div>
                <div class="col-md-6 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Minakshi Kumari</h5>
                    <h6 class="font-weight-bold my-2">Chandigarh Group of Colleges, Btech</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    </ul>
                    <p class="mb-2">
                    <i class="fas fa-quote-left pe-2"></i>very good training. there were the experts who gave us so much knowledge and i learnt so much new from them. kiran mam is the best teacher i have ever seen. and Ayan sir was also very nice to me
                    </p>
                </div>
                </div>
                <div class="col-md-6 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Prathamesh Omprakash Khairnar</h5>
                    <h6 class="font-weight-bold my-2">KBTCOE, Information Technology</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>It was very nice experience with this course and I have gained very much essential knowledge from this thanks to the team
                    </p>
                </div>
                </div>
                <div class="col-md-7 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Prashant Kumar</h5>
                    <h6 class="font-weight-bold my-2">G.L. Bajaj Institute of Technology and Management, Civil Engineering Department </h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>I have had a great experience learning with this internship . The tutors were really helpful and approachable . I would like to thank you for giving me this opportunity to learn and skill my level up.
                    </p>
                </div>
                </div>
                <div class="col-md-5 card">
                <div class="card-body">
                    <h5 class="font-weight-bold">Gagan Deep k</h5>
                    <h6 class="font-weight-bold my-2">VVIT, CSE</h6>
                    <ul class="list-unstyled d-flex justify-content-start">
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_yellow_color"></i>
                    </li>
                    <li>
                        <i class="fas fa-star fa-sm review_icon_white_color"></i>
                    </li>
                    </ul>
                    <p class="">
                    <i class="fas fa-quote-left pe-2"></i>It was very good experience training in the company and which helped me improve my skills and knowledge. The company provided very good knowledge on the field of training and about new technology in the professional field.
                    </p>
                </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default AI_Review_Program_Page
